'use strict';

function changeValue(value, percentage = false) {
    let change = value && value !== 0 ? value > 0 ? '+'+value : value : false;
    change = percentage && change ? change + ' %' : change;
    change = change ? '<span class="change-count">('+change+')</span>' : '';

    return change;
}

function changeDates(date, dateElems) {
    if (!dateElems) {
        return;
    }

    const formattedDate = date.format('D.M.YYYY');

    dateElems.forEach((elem) => {
        elem.textContent = formattedDate;
    });
}

function roundTo(n, digits) {
    if (digits === undefined) {
        digits = 0;
    }

    var multiplicator = Math.pow(10, digits);
    n = parseFloat((n * multiplicator).toFixed(11));
    return Math.round(n) / multiplicator;
}

export {
    changeValue,
    changeDates,
    roundTo
};
